/**
 * PNG snapshot of the live 3D graph canvas.
 *
 * Shared utility — both `DownloadDialog` (PNG button) and `ShareDialog`
 * ("Share Graph Image") use this. Keeps the canvas-id contract in one
 * place.
 *
 * The container id `force-graph-3d-infranodus` is owned by the
 * `infranodus-graph` package's 3D view. If that package renames the
 * container, this is the only file that needs updating.
 */

const GRAPH_CANVAS_CONTAINER_ID = 'force-graph-3d-infranodus'

/**
 * Snapshot the graph canvas to a PNG and trigger a browser download.
 * Returns true on success, false if the canvas isn't mounted yet.
 * Caller is expected to surface a user-visible message on false.
 */
export function downloadGraphPng({ filename } = {}) {
    const container = document.getElementById(GRAPH_CANVAS_CONTAINER_ID)
    const canvas = container?.querySelector('canvas')
    if (!canvas) return false

    const link = document.createElement('a')
    link.download = filename || `infranodus-${new Date().toISOString()}.png`
    link.href = canvas.toDataURL('image/png')
    link.click()
    return true
}
